<span *ngIf="field">
	<fa-icon icon="question" [tooltip]="tooltipTemplate" placement="auto" class="noprint custom-icon" [ngClass]="{'small-icon': isSmall}"></fa-icon>
	<ng-template #tooltipTemplate>
		<p><strong>{{ isTranslated ? field : ('tooltip.'+field | translate) }}</strong></p>
	</ng-template>
</span>
